// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer[data-v-4aaa7b40] {\n  position: absolute;\n  bottom: 0;\n  right: 20px;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  z-index: 99;\n  background-color: white;\n}\n.mb20[data-v-4aaa7b40] {\n  margin-bottom: 20px;\n}\n.cursor[data-v-4aaa7b40] {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
